import { IconRocket } from '@developerz/ui';
import { A } from '@solidjs/router';
import { type JSX, Show } from 'solid-js';
import { t } from '../i18n';
import { useOnboardingState } from '../lib/onboarding';
import { buttonClass } from './ui/Button';

// The way BACK into the funnel. Container — one read, the same query key Home's
// nudge already uses, so the two share a cache entry rather than a second poll.
//
// The wizard sends people out of itself (to the keys page, to GitHub, to Repos)
// and nothing brought them back: the rail had no entry, the command palette
// listed `onboarding: null`, and Home's nudge was the only door — reachable only
// by navigating to Home and only while the nudge's own predicate held. The
// predicate here is that same one (`!complete`), so a finished account sees
// nothing and a mid-funnel one always has a way in.
export function FinishSetupCta(props: { readonly resolve: (href: string) => string }): JSX.Element {
  const onboarding = useOnboardingState();
  // `data !== undefined` first: an unresolved funnel must not advertise setup to
  // an account that finished months ago, and must not hide it either — it says
  // nothing until it knows.
  const midFunnel = (): boolean => onboarding.data !== undefined && !onboarding.data.complete;
  return (
    <Show when={midFunnel()}>
      <A
        class={`${buttonClass({ variant: 'outline' })} app-sidebar__cta`}
        href={props.resolve('/onboarding')}
        data-rail-tip={t('nav.finish_setup')}
      >
        <IconRocket size="1rem" />
        {/* A span so the collapsed icon rail can hide the words, never the name (#7710). */}
        <span class="app-sidebar__cta-text">{t('nav.finish_setup')}</span>
      </A>
    </Show>
  );
}
